/*
 * Copyright (c) 2016 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {ClarityIcons} from "./index";
import {AllShapes} from "./shapes/all-shapes";

ClarityIcons.add(AllShapes);

export {ClarityIcons};



// WEBPACK FOOTER //
// ./src/clarity-icons/clarity-icons-sfx.ts